var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 30 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M7 11.19h5.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M26.777 12.518h-3.469C20.928 12.518 19 14.3 19 16.5s1.93 3.983 4.307 3.983h3.47c.112 0 .167 0 .214-.002.72-.044 1.293-.574 1.34-1.24.002-.042.002-.094.002-.196v-5.09c0-.103 0-.154-.002-.197-.048-.665-.62-1.195-1.34-1.239-.047-.002-.102-.002-.214-.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M26.953 12.518c-.104-2.486-.437-4.01-1.516-5.083-1.561-1.556-4.076-1.556-9.104-1.556h-4c-5.028 0-7.542 0-9.104 1.556-1.562 1.555-1.562 4.059-1.562 9.066s0 7.511 1.562 9.066 4.076 1.556 9.104 1.556h4c5.028 0 7.543 0 9.104-1.556 1.079-1.073 1.414-2.597 1.516-5.083"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m7 5.879 4.98-3.289a4.33 4.33 0 0 1 4.707 0l4.98 3.289"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.988 16.5h.013"
  })));
};
export default SvgWallet;